import React from 'react';
import HomeSettingComponent from '../../../components/admin/home/HomeSettingComponent';

const HomeSetting: React.FC = () => {
  return <HomeSettingComponent />;
};

export default HomeSetting;
